module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SiteHeader"
  }, [_c('div', {
    ref: "headroom",
    staticClass: "SiteHeader-headroom"
  }, [_c('container', {
    staticClass: "SiteHeader-container"
  }, [_c('div', {
    staticClass: "SiteHeader-content"
  }, [_c(!_vm.blockMenu ? 'router-link' : 'div', {
    tag: "component",
    staticClass: "SiteHeader-logo",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('logo', {
    nativeOn: {
      "click": function($event) {
        return _vm.hideMenu.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (!_vm.blockMenu) ? _c('nav', {
    staticClass: "SiteHeader-menu"
  }, _vm._l((_vm.global.menu), function(item, index) {
    return _c('router-link', {
      key: 'menuItem' + index,
      staticClass: "SiteHeader-menuItem",
      attrs: {
        "to": {
          path: item.path
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])
  }), 1) : _vm._e()], 1)]), _vm._v(" "), (!_vm.blockMenu) ? _c('div', {
    staticClass: "SiteHeader-menuButton"
  }, [_c('overlay-toggle', {
    attrs: {
      "inactive-label": "Menu",
      "active-label": "Close",
      "icon": "plus",
      "is-active": _vm.menu.isVisible
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6769d49a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteHeader.vue
// module id = 775
// module chunks = 1474